import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Col, Button, Accordion } from "react-bootstrap";

import { withNamespaces } from "react-i18next";
import { findIflowTasksByFilters } from "~/store/ducks/tasks/actionTypes";
import { BPM_MIDDLEWARE } from "~/utils/constants";

import FilterToggle from "~/components/Tasks/FilterToggle";

import DatePicker from "~/components/DatePicker";
import { subDays } from "date-fns";
import "~/assets/css/icons.css";
import { ADocumentStatus } from "../utils/ADatacaptureEnum";

import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import {
  getColorByStatusDocument,
  translateStatusDocument,
  translateApprovedDocument,
  getColorByApprovedDocument,
} from "../utils";

const AutomatedDocumentTableCustomFilterZone = (props) => {
  const {
    startAt,
    startPaymentAt,
    endAt,
    endPaymentAt,
    handleEndAt,
    handleEndPaymentAt,
    handleStartAt,
    handleStartPaymentAt,
    handleFornecedor,
    fornecedor,
    dateRadioValue,
    setDateRadioValue,
    approvedRadioValue,
    setApprovedRadioValue,
    setStatusRadioValue,
    setPaymentDateDefined,
    forceFiltersReset,
    checkSwitch,
    setCheckSwitch,
    t,
  } = props;
  const isMobile = window.innerWidth < 992 ? true : false;

  const [toggleIcon, setToggleIcon] = useState("icon-up");
  const [toggleIconMobile, setToggleIconMobile] = useState("icon-down");
  const [activeKey, setActiveKey] = useState(!isMobile ? "0" : null);
  const [activeKeyMobile, setActiveKeyMobile] = useState(null);
  const [filterToggle, setFilterToggle] = useState(false); //default hide
  const [filterToggleMobile, setFilterToggleMobile] = useState(true); //default mobile hide
  const [paidDate, setPaidDate] = useState(false);
  const [notPaidDate, setNotPaidDate] = useState(false);

  const approvedRadios = [
    {
      name: t("datacapture.filter.notApproved"),
      value: "1",
      variant: "danger",
    },
    { name: t("datacapture.filter.aproved"), value: "2", variant: "success" },
  ];

  const statusRadios = [
    { name: ADocumentStatus.PROCESSED, value: ADocumentStatus.PROCESSED },
    { name: ADocumentStatus.PROCESSING, value: ADocumentStatus.PROCESSING },
    { name: ADocumentStatus.DUPLICATED, value: ADocumentStatus.DUPLICATED },
  ];

  const setStatusRadioValueAux = (e) => {
    setStatusRadioValue(e);
  };

  const setApprovedRadioValueAux = (e) => {
    setApprovedRadioValue(e);
  };

  const setValuePaidDate = () => {
    setCheckSwitch(!checkSwitch);
    setPaidDate(!paidDate);
    setPaymentDateDefined(!checkSwitch);
  };

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {});
    useEffect(() => {
      setActiveKeyMobile(filterToggleMobile === false ? "0" : null);
      setToggleIconMobile(
        filterToggleMobile === false ? "icon-up" : "icon-down"
      );
      setActiveKey(filterToggle === false ? null : "0");
      setToggleIcon(filterToggle === false ? "icon-up" : "icon-down");
    }, [filterToggle]);

    return (
      <Col lg="12" onClick={decoratedOnClick} style={{ padding: "0px" }}>
        <h5>{t("general.filters")}</h5>
        <hr />
        {children}
      </Col>
    );
  };

  return (
    <Accordion activeKey={activeKey}>
      <FilterToggle
        eventKey="0"
        setToggleIcon={setToggleIcon}
        setActiveKey={setActiveKey}
        toggleIcon={toggleIcon}
        name="general.filters"
      />
      <Accordion.Collapse eventKey="0">
        <Form>
          <Form.Row>
            <Col lg="8" sm="12">
              <Form.Label>{t("datacapture.filter.suplier")}</Form.Label>
              <div>
                <Form.Control
                  type="text"
                  value={fornecedor}
                  onChange={(e) => handleFornecedor(e.target.value)}
                />
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col lg="4" sm="12">
              <Form.Label className="dataCapture_labels">
                {t("datacapture.filter.emissionDate")}
              </Form.Label>
              <DatePicker
                value={startAt}
                onChange={(e) => handleStartAt(e)}
                format="dd/MM/yyyy HH:mm:ss"
                style={{ flexGrow: "1", flexBasis: "0" }}
              />
            </Col>
            <Col lg="4" sm="12">
              <div className="dataCapture_inputs">
                <DatePicker
                  value={endAt}
                  onChange={(e) => handleEndAt(e)}
                  format="dd/MM/yyyy HH:mm:ss"
                  style={{ flexGrow: "1", flexBasis: "0" }}
                />
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col lg="4">
              <Form.Label>{t("datacapture.filter.paymentDate")}</Form.Label>
              <DatePicker
                value={startPaymentAt}
                onChange={(e) => handleStartPaymentAt(e)}
                format="dd/MM/yyyy HH:mm:ss"
                style={{ flexGrow: "1", flexBasis: "0" }}
              />
            </Col>
            <Col lg="4">
              <div className="dataCapture_inputs">
                <DatePicker
                  value={endPaymentAt}
                  onChange={(e) => handleEndPaymentAt(e)}
                  format="dd/MM/yyyy HH:mm:ss"
                  style={{ flexGrow: "1", flexBasis: "0" }}
                />
              </div>
            </Col>
          </Form.Row>
          <br></br>
          {/* <Form.Row> */}
          {/* <Form.Label style={{ paddingLeft: "5px" }}> */}{" "}
          <div className="dataCapture_title">
            <h6>{t("datacapture.filter.approvalStatus")}</h6>
          </div>
          {/* </Form.Label> */}
          {/* </Form.Row> */}
          <div className="dataCapture_groupButtons">
            <Form.Row>
              <ButtonGroup>
                {approvedRadios.map((radio, idx) => (
                  <ToggleButton
                    style={idx === 1 ? { marginLeft: "15px" } : {}}
                    key={idx}
                    id={`radio-${idx}`}
                    type="radio"
                    variant={radio.variant}
                    name="radio"
                    value={radio.value}
                    checked={approvedRadioValue === radio.value}
                    onChange={(e) =>
                      setApprovedRadioValueAux(e.currentTarget.value)
                    }
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </Form.Row>
          </div>
          {/* <Form.Row>
            <Form.Label style={{ paddingLeft: "5px" }}> */}{" "}
          <div className="dataCapture_title" style={{ marginTop: "10px" }}>
            <h6>{t("datacapture.filter.paymentStatus")}</h6>
          </div>
          {/* </Form.Label>
          </Form.Row> */}
          <div className="dataCapture_groupButtons">
            <Form.Row>
              <ButtonGroup>
                <Form.Check
                  disabled={approvedRadioValue === "1"}
                  style={{ marginLeft: "5px" }}
                  type="switch"
                  id="custom-switch"
                  checked={checkSwitch}
                  onClick={setValuePaidDate}
                  label={t("datacapture.filter.payed")}
                />
              </ButtonGroup>
            </Form.Row>
          </div>
        </Form>
      </Accordion.Collapse>
    </Accordion>
  );
};
export default withNamespaces()(AutomatedDocumentTableCustomFilterZone);
